import { Component, effect, linkedSignal, model, WritableSignal } from '@angular/core';
import { SelectedTimeReportTypeEnum } from '@app/shared/types/models/reports/time-report-panel.model';
import { UiDateRangePickerComponent } from '@app/shared/ui/date-range-picker/ui-date-range-picker.component';
import { ProffeoUiDateRange } from '@app/shared/ui/types/date-picker.types';
import { DateRange } from '../../../types/models/reports/new/date-range';

@Component({
  selector: 'date-range-input',
  imports: [UiDateRangePickerComponent],
  templateUrl: './date-range-input.component.html',
  styleUrl: './date-range-input.component.scss'
})
export class DateRangeInputComponent {
  protected readonly SelectedTimeReportTypeEnum = SelectedTimeReportTypeEnum;

  protected readonly rangeValue: WritableSignal<ProffeoUiDateRange> = linkedSignal(() => ({
    start: this.dateRangeSelected()?.start ?? null,
    end: this.dateRangeSelected()?.end ?? null
  }));

  public readonly selectedTimeMode = model<SelectedTimeReportTypeEnum>();
  public readonly dateRangeSelected = model<DateRange>();

  public constructor() {
    effect(() => {
      const range = this.rangeValue();
      if (!range.start || !range.end) {
        return;
      }

      this.selectedTimeMode.set(SelectedTimeReportTypeEnum.RANGE);

      const current = this.dateRangeSelected();
      if (
        (current?.start?.getTime() ?? null) !== range.start.getTime() ||
        (current?.end?.getTime() ?? null) !== range.end.getTime()
      ) {
        this.dateRangeSelected.set({ start: range.start, end: range.end });
      }
    });
  }
}
